<template>
    <v-container fluid>
        <h1 class="heading" style="margin-top: 5rem;">2026 Race</h1>

        <v-row class="scroller-container" @mouseover="pauseScrolling" @mouseleave="startScrolling" justify="center">
            <div class="scroller" ref="Race2026Scroller">
                <v-col
                    v-for="(img, index) in imgs.Race2026"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="3"
                    lg="4"
                    class="img-container"
                >
                    <v-img
                        :src="img"
                        class="img"
                        aspect-ratio="0.8"
                        contain
                        @click="openCarousel(index, 'Race2026')"
                    ></v-img>
                </v-col>
            </div>
        </v-row>

        <!-- Carousel for Race2026 Images -->
        <div v-show="showCarousel.Race2026" class="carousel-container">
            <div class="carousel">
                <div class="closeCarousel">
                    <v-icon
                        large
                        color="white"
                        style="cursor:pointer"
                        @click="closeCarousel('Race2026')"
                    >
                        mdi-close-circle
                    </v-icon>
                </div>
                <v-carousel
                    v-model="carousel.Race2026"
                    hide-delimiters
                    :continuous="false"
                    height="100%"
                >
                    <v-carousel-item
                        eager
                        v-for="(img, index) in imgs.Race2026"
                        :key="index"
                        class="v-carousel"
                    >
                        <v-img
                            eager
                            class="carousel-img"
                            :src="img"
                            contain
                        ></v-img>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </div>

        
        <h1 class="heading">Progress</h1>

        <v-row class="scroller-container" justify="center" @mouseover="pauseScrolling" @mouseleave="startScrolling">
            <div class="scroller" ref="ProgressScroller">
                <v-col
                    v-for="(img, index) in imgs.Progress"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="3"
                    lg="2"
                    class="img-container"
                >
                    <v-img
                        :src="img"
                        class="img"
                        aspect-ratio="0.5"
                        contain
                        @click="openCarousel(index, 'Progress')"
                    ></v-img>
                </v-col>
            </div>
        </v-row>

        <div v-show="showCarousel.Progress" class="carousel-container">
            <div class="carousel">
                <div class="closeCarousel">
                    <v-icon
                        large
                        color="white"
                        style="cursor:pointer"
                        @click="closeCarousel('Progress')"
                    >
                        mdi-close-circle
                    </v-icon>
                </div>
                <v-carousel
                    v-model="carousel.Progress"
                    hide-delimiters
                    :continuous="false"
                    height="100%"
                >
                    <v-carousel-item
                        eager
                        v-for="(img, index) in imgs.Progress"
                        :key="index"
                        class="v-carousel"
                    >
                        <v-img
                            eager
                            class="carousel-img"
                            :src="img"
                            contain
                        ></v-img>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    name: "Gallery",
    data() {
        const Race2026Images = this.importAllImages(
            require.context('@/assets/race26', false, /\.(png|jpe?g|svg|jpg|JPG)$/)
        );
        const ProgressImages = this.importAllImages(
            require.context('@/assets/sponsors/Progress', false, /\.(png|jpe?g|svg|jpg|JPG)$/)
        );

        return {
            showCarousel: {
                Race2026: false,
                Progress: false
            },
            carousel: {
                Race2026: 0,
                Progress: 0
            },
            imgs: {
                Race2026: Race2026Images,
                Progress: ProgressImages
            },
            scrollingInterval: null,
            scrollSpeed: 1,
            lastPaused: 0
        };
    },
    mounted() {
        this.startScrolling(); 
    },
    beforeDestroy() {
        this.pauseScrolling(); 
    },
    methods: {
        openCarousel(index, type) {
            this.carousel[type] = index;
            this.showCarousel[type] = true;
        },
        closeCarousel(type) {
            this.carousel[type] = 0;
            this.showCarousel[type] = false;
        },
        importAllImages(r) {
            return r.keys().map(r);
        },
        startScrolling() {
            this.lastPaused = 0
            this.scrollingInterval = setInterval(() => {
                const Race2026Scroller = this.$refs.Race2026Scroller;
                const ProgressScroller = this.$refs.ProgressScroller;

                if (Race2026Scroller) {
                    Race2026Scroller.scrollLeft += this.scrollSpeed;
                    if (Race2026Scroller.scrollLeft + Race2026Scroller.clientWidth >= Race2026Scroller.scrollWidth) {
                        Race2026Scroller.scrollLeft = 0;
                    }
                }

                if (ProgressScroller) {
                    ProgressScroller.scrollLeft += this.scrollSpeed;
                    if (ProgressScroller.scrollLeft + ProgressScroller.clientWidth >= ProgressScroller.scrollWidth) {
                        ProgressScroller.scrollLeft = 0;
                    }
                }
            }, 10); 
        },
        pauseScrolling() {
            clearInterval(this.scrollingInterval);
            this.scrollingInterval = null;
            let  curTime = Date.now()
            this.lastPaused = curTime
            setTimeout(() => {
                if (this.lastPaused === curTime) {
                    // this.pauseScrolling()
                    clearInterval(this.scrollingInterval);
                    this.scrollingInterval = null;
                    this.startScrolling()
                }
            },2500)
        }
    }
};
</script>

<style lang="scss" scoped>
.heading {
    margin-top: 20px;
    text-align: center;
    font-weight: 600;
    font-size: 2em;
    color: #333;
}

.scroller-container {
    overflow-x: hidden; 
    white-space: nowrap;
    position: relative;
    width: 100%;
}

.scroller {
    display: flex;
    // overflow-x: hidden; 
    overflow-y: hidden;
    flex-wrap: nowrap;
    // overflow-x: auto;
    width: 80%
}

.img-container {
    flex: 0 0 auto;
    transition: transform 0.3s, box-shadow 0.3s;
    cursor: pointer;
    margin: 10px;
    &:hover {
        transform: scale(1.05);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    }
}

.img {
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: auto;
    object-fit: cover;
}

.carousel-container {
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
}

.carousel {
    z-index: 5;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
}

.closeCarousel {
    position: absolute;
    z-index: 6;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

.v-carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
}

.carousel-img {
    max-height: 80vh;
    max-width: 90vw;
}
</style>
